const showDataSC = (couponName, carType, serviceCoupon, price) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `showDataSC`,
      showPDP: {
        data: [
          {
            couponName: couponName?.toLowerCase(),
            carType: carType?.toLowerCase(),
            serviceCoupon: serviceCoupon?.toLowerCase(),
            price: price,
          },
        ],
      },
    });
  }
};
export default showDataSC;
